"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callFunctionOn = callFunctionOn;
exports.enable = enable;
exports.getProperties = getProperties;
exports.evaluate = evaluate;
exports.releaseObject = releaseObject;
exports.globalLexicalScopeNames = globalLexicalScopeNames;
var connector_1 = __importDefault(require("../lib/connector"));
var each_1 = __importDefault(require("licia/each"));
var map_1 = __importDefault(require("licia/map"));
var now_1 = __importDefault(require("licia/now"));
var isStr_1 = __importDefault(require("licia/isStr"));
var fnParams_1 = __importDefault(require("licia/fnParams"));
var uncaught_1 = __importDefault(require("licia/uncaught"));
var startWith_1 = __importDefault(require("licia/startWith"));
var stackTrace_1 = __importDefault(require("licia/stackTrace"));
var trim_1 = __importDefault(require("licia/trim"));
var objManager = __importStar(require("../lib/objManager"));
var evaluate_1 = require("../lib/evaluate");
var util_1 = require("../lib/util");
var executionContext = {
    id: 1,
    name: 'top',
    origin: location.origin,
};
function callFunctionOn(params) {
    return __awaiter(this, void 0, void 0, function () {
        var functionDeclaration, objectId, args, ctx, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    functionDeclaration = params.functionDeclaration, objectId = params.objectId;
                    args = params.arguments || [];
                    args = (0, map_1.default)(args, function (arg) {
                        var objectId = arg.objectId, value = arg.value;
                        if (objectId) {
                            var obj = objManager.getObj(objectId);
                            if (obj)
                                return obj;
                        }
                        return value;
                    });
                    ctx = null;
                    if (objectId) {
                        ctx = objManager.getObj(objectId);
                    }
                    _c = {};
                    _b = (_a = objManager).wrap;
                    return [4, callFn(functionDeclaration, args, ctx)];
                case 1: return [2, (_c.result = _b.apply(_a, [_d.sent()]),
                        _c)];
            }
        });
    });
}
var isEnable = false;
function enable() {
    isEnable = true;
    (0, each_1.default)(triggers, function (trigger) { return trigger(); });
    triggers = [];
    trigger('Runtime.executionContextCreated', {
        context: executionContext,
    });
}
function getProperties(params) {
    return objManager.getProperties(params);
}
var isAsyncSupported = true;
try {
    eval('async () => {}');
}
catch (e) {
    isAsyncSupported = false;
}
function evaluate(params) {
    return __awaiter(this, void 0, void 0, function () {
        var ret, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ret = {};
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (params.throwOnSideEffect && hasSideEffect(params.expression)) {
                        throw EvalError('Possible side-effect in debug-evaluate');
                    }
                    if (!(isAsyncSupported && (params.replMode || params.awaitPromise))) return [3, 3];
                    return [4, (0, evaluate_1.evalJsAsync)(params.expression)];
                case 2:
                    result = _a.sent();
                    return [3, 4];
                case 3:
                    result = (0, evaluate_1.evalJs)(params.expression);
                    _a.label = 4;
                case 4:
                    (0, evaluate_1.setGlobal)('$_', result);
                    ret.result = objManager.wrap(result, {
                        generatePreview: true,
                    });
                    return [3, 6];
                case 5:
                    e_1 = _a.sent();
                    ret.exceptionDetails = {
                        exception: objManager.wrap(e_1),
                        text: 'Uncaught',
                    };
                    ret.result = objManager.wrap(e_1, {
                        generatePreview: true,
                    });
                    return [3, 6];
                case 6: return [2, ret];
            }
        });
    });
}
function releaseObject(params) {
    objManager.releaseObj(params.objectId);
}
function globalLexicalScopeNames() {
    return {
        names: [],
    };
}
function monitorConsole() {
    var methods = {
        log: 'log',
        warn: 'warning',
        error: 'error',
        info: 'info',
        dir: 'dir',
        table: 'table',
        group: 'startGroup',
        groupCollapsed: 'startGroupCollapsed',
        groupEnd: 'endGroup',
        debug: 'debug',
        clear: 'clear',
    };
    (0, each_1.default)(methods, function (type, name) {
        if (!console[name]) {
            return;
        }
        var lastTimestamp = 0;
        var origin = console[name].bind(console);
        console[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            origin.apply(void 0, args);
            args = (0, map_1.default)(args, function (arg) {
                return objManager.wrap(arg, {
                    generatePreview: true,
                });
            });
            var timestamp = (0, util_1.getTimestamp)();
            if (timestamp <= lastTimestamp) {
                timestamp = lastTimestamp + 0.001;
            }
            lastTimestamp = timestamp;
            trigger('Runtime.consoleAPICalled', {
                type: type,
                args: args,
                stackTrace: {
                    callFrames: type === 'error' || type === 'warning' ? getCallFrames() : [],
                },
                executionContextId: executionContext.id,
                timestamp: timestamp,
            });
        };
    });
}
var Function = window.Function;
var AsyncFunction = Object.getPrototypeOf(function () {
    return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2];
    }); });
}).constructor;
function parseFn(fnStr) {
    var result = (0, fnParams_1.default)(fnStr);
    if (fnStr[fnStr.length - 1] !== '}') {
        result.push('return ' + fnStr.slice(fnStr.indexOf('=>') + 2));
    }
    else {
        result.push(fnStr.slice(fnStr.indexOf('{') + 1, fnStr.lastIndexOf('}')));
    }
    return result;
}
function callFn(functionDeclaration_1, args_1) {
    return __awaiter(this, arguments, void 0, function (functionDeclaration, args, ctx) {
        var fnParams, fn;
        if (ctx === void 0) { ctx = null; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fnParams = parseFn(functionDeclaration);
                    if (!(0, startWith_1.default)(functionDeclaration, 'async')) return [3, 2];
                    fn = AsyncFunction.apply(null, fnParams);
                    return [4, fn.apply(ctx, args)];
                case 1: return [2, _a.sent()];
                case 2:
                    fn = Function.apply(null, fnParams);
                    return [2, fn.apply(ctx, args)];
            }
        });
    });
}
uncaught_1.default.addListener(function (err) {
    trigger('Runtime.exceptionThrown', {
        exceptionDetails: {
            exception: objManager.wrap(err),
            stackTrace: { callFrames: getCallFrames(err) },
            text: 'Uncaught',
        },
        timestamp: now_1.default,
    });
});
function hasSideEffect(code) {
    return !/^[a-zA-Z0-9]*$/.test(code);
}
function getCallFrames(error) {
    var callFrames = [];
    var callSites = error ? error.stack : (0, stackTrace_1.default)();
    if ((0, isStr_1.default)(callSites)) {
        callFrames = callSites.split('\n');
        if (!error) {
            callFrames.shift();
        }
        callFrames.shift();
        callFrames = (0, map_1.default)(callFrames, function (val) { return ({ functionName: (0, trim_1.default)(val) }); });
    }
    else if (callSites) {
        callSites.shift();
        callFrames = (0, map_1.default)(callSites, function (callSite) {
            return {
                functionName: callSite.getFunctionName(),
                lineNumber: callSite.getLineNumber(),
                columnNumber: callSite.getColumnNumber(),
                url: callSite.getFileName(),
            };
        });
    }
    return callFrames;
}
var triggers = [];
function trigger(method, params) {
    if (isEnable) {
        connector_1.default.trigger(method, params);
    }
    else {
        triggers.push(function () { return connector_1.default.trigger(method, params); });
    }
}
uncaught_1.default.start();
monitorConsole();
